import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { useInjectSaga } from 'utils/injectSaga';
import saga from 'ui/containers/App/saga';
import Conversation from 'ui/containers/Conversation';
import * as actions from 'ui/containers/App/actions';
import * as selectors from 'ui/containers/App/selectors';
import { PAGE } from 'common/constants';
// import Pusher from 'pusher-js';
import Launcher from 'ui/containers/Launcher';
import NewPopup from 'ui/containers/NewPopup';
import Home from 'ui/containers/Home';
import {
  PUSHER_STATES,
  NATIVE_NOTIFICATION_VARIANT,
  NETWORK_STATUS,
  WINDOW_POSTMESSAGE_TYPES,
  SENDING_MESSAGE_TYPE,
  PUSHER_EVENT_TYPES,
} from './constants';
import { REACT_APP_BASE_URL_BE as baseUrl} from 'config.js';
import useResizeIframe from 'utils/hooks/useResizeIframe';
import localStorageTemplates from 'common/local-storage-templates';
import isSessionActive from 'utils/isSessionActive';
import {
  saveEventToLocalStorage,
  saveToLocalStorage,
  getFromLocalStorage,
  deleteFromLocalStorage,
  clearLocalStorage,
} from 'utils/saveToLocalStorage';
import { eventTypes } from 'utils/eventTypes';
import uuid from "utils/uuid";
import isConversationDisabled from 'utils/isConversationDisabled';
import { addStackTraceToLocalStorage } from 'utils/debugger';
import {setServerMessagesQueue} from "ui/containers/App/actions";
import { postMessageToWindow } from 'utils/index';
import { useConfig } from 'context';


const AppContainer = styled.div`
  z-index: ${p => p.theme.zIndex.base};
  margin: 0px;
  display: block;
  overflow: hidden;
  width: 100%;
`;

const Dimmer = styled.div`
  box-shadow: 0 0 0 100vmax rgba(0, 0, 0, .5);
  position: absolute;
  z-index: -1;
`;

const App = props => {
  useInjectSaga({ key: 'global', saga });
  const {
    getInitialState,
    getChannelId,
    currentPage,
    subscriptionChannel,
    userData,
    processPusherUpdates,
    processClientMessages,
    setCurrentChannel,
    setActivePageStart,
    userConfig,
    handleSendingMessageToPusher,
    setInternetStatus,
    currentChannel,
    updateReadStatus,
    getUserConversation,
    networkCurrentStatus,
    parentFrameSize,
    popupToNotificationMessage,
    setPopupToNotificationMessageStart,
    setTimeSpentStart,
    triggerForms,
    triggerElements,
    formFields,
    isMessageUnread,
    setIsMessageUnreadStart,
    setIsPusherConnected,
    setNotificationRead,
    notificationRead,
    agentNewMessageList,
    setWidgetVisibility,
    handleWidgetEvent,
    initiateSocketConnection,
    delayFlag,
    serverMessagesQueue,
    userSettingBot,
  } = props;
  const pusher = useRef();
  const isPusherConnected = useRef();
  const subscriptionChannelRef = useRef();
  const eventListenerNameRef = useRef();
  const isPageFocused = useRef(true);
  const isWindowFocused = useRef(false);
  const [showNewMessageNotification, setShowNewMessageNotification] = useState(false);
  const networkStatus = useRef(NETWORK_STATUS.online);
  const popupToNotificationTimeoutId = useRef();
  const [popup, setPopup] = useState({});
  const [nativeNotification, setNativeNotification] = useState({
    variant: NATIVE_NOTIFICATION_VARIANT.success,
    message: null,
  });
  const [showDimmer, setShowDimmer] = useState(false);
  const insentTimeSpentIntervalId = useRef();
  const intervalTimeRef = useRef();
  const insentPageTimeSpent = useRef();
  const currentPageRef = useRef();
  const activeIntervals = useRef({});
  const messagesToBeSentToPusher = useRef([]);
  const { config, loading: configLoading, error: configError, hasConfig } = useConfig();
  
  const {REACT_APP_PUSHER_TOKEN: pusherToken, REACT_APP_PUSHER_CLUSTER: pusherCluster, REACT_APP_SESSION_TIME} = config || {};
  let validBaseUrl = baseUrl;
  if (baseUrl) {
    const lastChar = baseUrl.substr(-1);
    validBaseUrl = lastChar === '/' ? baseUrl : `${baseUrl}/`;
  };
  window.insentBlogUrl = userConfig.blogUrl;
  window.insentCurrentPage = currentPage;

  const setTimeSpentInterval = () => {
    clearInterval(insentTimeSpentIntervalId.current);
    delete activeIntervals.current[insentTimeSpentIntervalId.current];
    return setInterval(function() {
      const currentTime = Date.now();
      if (intervalTimeRef.current && (isPageFocused.current || isWindowFocused.current)) {
        setTimeSpentStart({
          meta: {},
          payload: { timeDiff: Math.round((currentTime - insentPageTimeSpent.current) / 1000) },
        });
        insentPageTimeSpent.current = currentTime;
      } else {
        if (insentTimeSpentIntervalId.current) {
          setTimeSpentStart({
            meta: {},
            payload: { timeDiff: Math.round((currentTime - insentPageTimeSpent.current) / 1000) },
          });
          insentPageTimeSpent.current = currentTime;
          clearInterval(insentTimeSpentIntervalId.current);
          delete activeIntervals.current[insentTimeSpentIntervalId.current];
        }
      }
    }, intervalTimeRef.current * 1000);
  };

  // @dev a hook function thats handle the dynamic resizing of widget iframe
  useResizeIframe(
      currentPage,
      userConfig.eventListenerName,
      setShowNewMessageNotification,
      parentFrameSize,
      { shouldNewMessagePopupExpand: agentNewMessageList.length > 0, isFormFactor: false },
      userSettingBot,
  );

  useEffect(() => {
    setTimeout(() => {
      if (userConfig.eventListenerName) {
        eventListenerNameRef.current = userConfig.eventListenerName;
      }
    }, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userConfig.eventListenerName]);

  useEffect(() => {
    setTimeout(() => {
      let readNotification = getFromLocalStorage(localStorageTemplates.notificationRead) || 0;
      setNotificationRead(readNotification);
    },0);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (!delayFlag && serverMessagesQueue.length !== 0) {
        let message = serverMessagesQueue.shift();
        processPusherUpdates(message);
        setServerMessagesQueue(serverMessagesQueue);
      }

      while (messagesToBeSentToPusher.current.length != 0 && isPusherConnected.current) {
        handleSendingMessageToPusher(messagesToBeSentToPusher.current.shift());
      }
    },0);
  });

  const windowHasFocus = () => {
    saveToLocalStorage(localStorageTemplates.widgetLastActiveTime, Date.now());
    if (!isWindowFocused.current && isMessageUnread) {
      updateReadStatus();
      setIsMessageUnreadStart(false);
    }

    isWindowFocused.current = true;
    clearInterval(insentTimeSpentIntervalId.current);
    delete activeIntervals.current[insentTimeSpentIntervalId.current];
    insentPageTimeSpent.current = Date.now();
    insentTimeSpentIntervalId.current = setTimeSpentInterval();
    activeIntervals.current[insentTimeSpentIntervalId.current] = Date.now();
  };

  const windowNotHaveFocus = () => {
    saveToLocalStorage(localStorageTemplates.widgetLastActiveTime, Date.now());
    isWindowFocused.current = false;
    if (!isPageFocused.current && !isWindowFocused.current) {
      const currentTime = Date.now();
      setTimeSpentStart({
        meta: {},
        payload: { timeDiff: Math.round((currentTime - insentPageTimeSpent.current) / 1000) },
      });
      insentPageTimeSpent.current = currentTime;
      clearInterval(insentTimeSpentIntervalId.current);
      delete activeIntervals.current[insentTimeSpentIntervalId.current];
    }
  };

  const handleMessage = event => {
    if (event.data.type === eventListenerNameRef.current) {
      switch (event.data.event) {
        case WINDOW_POSTMESSAGE_TYPES.pageFocus:
          isPageFocused.current = event.data.focus;
          clearInterval(insentTimeSpentIntervalId.current);
          delete activeIntervals.current[insentTimeSpentIntervalId.current];
          insentPageTimeSpent.current = Date.now();
          insentTimeSpentIntervalId.current = setTimeSpentInterval();
          activeIntervals.current[insentTimeSpentIntervalId.current] = Date.now();
          break;
        case WINDOW_POSTMESSAGE_TYPES.pageBlur:
          isPageFocused.current = event.data.focus;
          if (!isPageFocused.current && !isWindowFocused.current) {
            const currentTime = Date.now();
            setTimeSpentStart({
              meta: {},
              payload: { timeDiff: Math.round((currentTime - insentPageTimeSpent.current) / 1000) },
            });
            insentPageTimeSpent.current = currentTime;
            clearInterval(insentTimeSpentIntervalId.current);
            delete activeIntervals.current[insentTimeSpentIntervalId.current];
          }
          break;
        case WINDOW_POSTMESSAGE_TYPES.changePage:
          if(currentPageRef.current === PAGE.DIMMED_CONVO) setActivePageStart(PAGE.CONVO);
          break;
        case WINDOW_POSTMESSAGE_TYPES.formSubmit:
          const formData = event.data.formData;
          if (formData && formData.channelId) {
            saveToLocalStorage(localStorageTemplates.activeChannelId, formData.channelId);
            setCurrentChannel({channelId: formData.channelId});
            setActivePageStart(PAGE.DIMMED_CONVO);
            setShowDimmer(true);
          }
          break;
        case WINDOW_POSTMESSAGE_TYPES.clickElementSubmit:
          const buttonData = event.data.elementData;
          if (buttonData && buttonData.channelId) {
            setCurrentChannel({channelId: buttonData.channelId});
            setActivePageStart(PAGE.DIMMED_CONVO);
            setShowDimmer(true);
          }
          break;
        case WINDOW_POSTMESSAGE_TYPES.widgetVisibility:
          const widgetVisibility = event.data.widgetVisibility;
          setWidgetVisibility({
            meta: { widgetVisibility },
          });
          break;
        case WINDOW_POSTMESSAGE_TYPES.widgetExpand:
          handleWidgetEvent({
            meta: { event: event.data.event },
          });
          break;
        case WINDOW_POSTMESSAGE_TYPES.widgetMinimize:
          handleWidgetEvent({
            meta: { event: event.data.event },
          });
          break;
        case WINDOW_POSTMESSAGE_TYPES.websiteForm:
          let eventData = JSON.parse(event.data.eventData);
          const events = JSON.parse(getFromLocalStorage('events') || '[]');
          events.push(eventData);
          saveToLocalStorage('events', JSON.stringify(events));
          break;
        case WINDOW_POSTMESSAGE_TYPES.clearLocalStorage:
          clearLocalStorage();
          break;
        case WINDOW_POSTMESSAGE_TYPES.showConversation:
          getChannelId(
              {
                meta:
                {
                  convId: event.data.data.convId,
                  dimBackground: event.data.data.dimBackground,
                  checkSendingMessages,
                }
              });
          break;
        case WINDOW_POSTMESSAGE_TYPES.sendCustomCookies:
          sendDataToServer({
            type: SENDING_MESSAGE_TYPE.cookies,
            data: { customCookies: event?.data?.data.customCookies }
          });
          break;
      }
    }
  };

  useEffect(() => {
    setTimeout(() => {
      window.removeEventListener('focus', windowHasFocus);
      window.addEventListener('focus', windowHasFocus);
    }, 0);
    return () => window.removeEventListener('focus', windowHasFocus);
  }, [isMessageUnread]);

  useEffect(() => {
    window.addEventListener('message', handleMessage);
    getInitialState({ sessionTime: REACT_APP_SESSION_TIME });
    window.addEventListener('blur', windowNotHaveFocus);
    saveToLocalStorage('pathEvents', JSON.stringify([]));
    return () => {
      window.removeEventListener('blur', windowNotHaveFocus);
      saveToLocalStorage('pathEvents', JSON.stringify([]));
      removeAllSubscriptionAndBindingInPusher();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if ((currentPage === PAGE.CONVO || currentPage === PAGE.DIMMED_CONVO) || initiateSocketConnection) {
        if (subscriptionChannel && subscriptionChannel.length) {
          subscriptionChannelRef.current = subscriptionChannel;
          subscribeToChannel();
          pusher.current = createPusherObject();
          if (pusher.current && pusher.current.connection) pusher.current.connection.bind('state_change', handleConnectionStateChange);
          window.addEventListener(NETWORK_STATUS.online, handleConnectionChange);
          window.addEventListener(NETWORK_STATUS.offline, handleConnectionChange);
        }
      }
    },0);

    return () => {
      if (subscriptionChannel && subscriptionChannel.length) {
        window.removeEventListener(NETWORK_STATUS.online, handleConnectionChange);
        window.removeEventListener(NETWORK_STATUS.offline, handleConnectionChange);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptionChannel]);

  useEffect( () => {
    setTimeout(() => {
      if (isPusherConnected.current !== true && (currentPage === PAGE.CONVO || currentPage === PAGE.DIMMED_CONVO)) {
        if (subscriptionChannel && subscriptionChannel.length) {
          subscriptionChannelRef.current = subscriptionChannel;
          subscribeToChannel();
          isPusherConnected.current = true;
          pusher.current = createPusherObject();
          pusher.current.connection.bind('state_change', handleConnectionStateChange);
          window.addEventListener(NETWORK_STATUS.online, handleConnectionChange);
          window.addEventListener(NETWORK_STATUS.offline, handleConnectionChange);
        }
      }
    },0);

    return () => {
      if (subscriptionChannel && subscriptionChannel.length) {
        window.removeEventListener(NETWORK_STATUS.online, handleConnectionChange);
        window.removeEventListener(NETWORK_STATUS.offline, handleConnectionChange);
      }
    };
  }, [currentPage])

  useEffect(() => {
    setTimeout(() => {
      if (userData && userData.session) {
        const {eventListenerName, userId} = userConfig;
        const event = WINDOW_POSTMESSAGE_TYPES.initialData;
        const intervalTime = userData.session.updateInterval;
        intervalTimeRef.current = intervalTime;
        const pageSessionId = userData.session.id;

      if (eventListenerName && userId && intervalTime && pageSessionId) {
        postMessageToWindow(
          {
            type: eventListenerName,
            event,
            userId,
            intervalTime,
            pageSessionId,
          },
          '*'
        );
        clearInterval(insentTimeSpentIntervalId.current);
        delete activeIntervals.current[insentTimeSpentIntervalId.current];
        insentPageTimeSpent.current = Date.now();
        insentTimeSpentIntervalId.current = setTimeSpentInterval();
        activeIntervals.current[insentTimeSpentIntervalId.current] = Date.now();
      }
      if (userData && userData.settings) {
        showWidget();
      }
      }
  },0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  useEffect(() => {
    if (triggerForms && triggerForms.length > 0) {
      const { eventListenerName, userId } = userConfig;
      postMessageToWindow(
        {
          type: eventListenerName,
          event: WINDOW_POSTMESSAGE_TYPES.triggerForm,
          userId,
          triggerForms,
        },
        '*'
      );
    }
  }, [triggerForms]);

  useEffect(() => {
    if (formFields && formFields.length > 0) {
      const { eventListenerName, userId } = userConfig;
      postMessageToWindow(
          {
            type: eventListenerName,
            event: WINDOW_POSTMESSAGE_TYPES.mappedFormFields,
            userId,
            formFields,
          },
          '*'
      );
    }
  }, [formFields])

  useEffect(() => {
    if (triggerElements && triggerElements.length > 0) {
      const { eventListenerName, userId } = userConfig;
      postMessageToWindow(
          {
            type: eventListenerName,
            event: WINDOW_POSTMESSAGE_TYPES.triggerElement,
            userId,
            triggerElements,
          },
          '*'
      );
    }
  }, [triggerElements]);

  useEffect(() => {
    setTimeout(() => {
      if (networkCurrentStatus === NETWORK_STATUS.online && currentChannel) {
        subscribeToChannel({callApi: true, cid: currentChannel});
      }
    },0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [networkCurrentStatus]);

  // Retry Pusher connection when config becomes available
  useEffect(() => {
    if (hasConfig && pusherToken && !isPusherConnected.current && subscriptionChannel) {
      // this log is important to debug the pusher connection retry
      console.log('Config loaded, retrying Pusher connection');
      if ((currentPage === PAGE.CONVO || currentPage === PAGE.DIMMED_CONVO) || initiateSocketConnection) {
        subscriptionChannelRef.current = subscriptionChannel;
        subscribeToChannel();
        pusher.current = createPusherObject();
        if(pusher.current && pusher.current.connection) {
          pusher.current.connection.bind('state_change', handleConnectionStateChange);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasConfig, pusherToken, subscriptionChannel, currentPage, initiateSocketConnection]);

  useEffect(() => {
    currentPageRef.current = currentPage;
    if (currentPage === PAGE.POPUP_CONNECTED || currentPage === PAGE.CONVO || currentPage == PAGE.DIMMED_CONVO) {
      postMessageToWindow(
        {
          type: eventListenerNameRef.current,
          event: WINDOW_POSTMESSAGE_TYPES.isSessionActive,
        },
        '*'
      );
    } else {
      postMessageToWindow(
        {
          type: eventListenerNameRef.current,
          event: WINDOW_POSTMESSAGE_TYPES.sessionNotActive,
        },
        '*'
      );
    }
    if (currentPage) {
      if (
        currentPage === PAGE.POPUP_CONNECTED ||
        currentPage === PAGE.POPUP_NEW_MESSAGE ||
        currentPage === PAGE.POPUP_NORMAL
      ) {
        saveToLocalStorage(localStorageTemplates.widgetActivePage, PAGE.LAUNCHER);
      } else {
        window.top.postMessage(
            {
              type: eventListenerNameRef.current,
              event: WINDOW_POSTMESSAGE_TYPES.sessionNotActive,
            },
            '*'
        );
      }
      if (currentPage) {
        if (
            currentPage === PAGE.POPUP_CONNECTED ||
            currentPage === PAGE.POPUP_NEW_MESSAGE ||
            currentPage === PAGE.POPUP_NORMAL
        ) {
          saveToLocalStorage(localStorageTemplates.widgetActivePage, PAGE.LAUNCHER);
        } else {
          saveToLocalStorage(localStorageTemplates.widgetActivePage, currentPage);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  useEffect(() => {
    setTimeout(() => {
      if (
          popupToNotificationMessage &&
          popupToNotificationMessage.length &&
          currentPage === PAGE.HOME &&
          popupToNotificationTimeoutId.current
      ) {
        setNativeNotification({
          variant: NATIVE_NOTIFICATION_VARIANT.success,
          message: null,
        });
        popupToNotificationTimeoutId.current = null;
      }
    },0);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [popupToNotificationMessage, currentPage]);

  const removeAllSubscriptionAndBindingInPusher = () => {
    if (
      subscriptionChannelRef.current &&
      pusher.current &&
      pusher.current.channel(subscriptionChannelRef.current)
    ) {
      pusher.current.channel(subscriptionChannelRef.current).unbind();
      pusher.current.unsubscribe(subscriptionChannelRef.current);
    }
  };

  const createPusherObject = () => {
    if (pusher.current) {
      return pusher.current;
    }

    const { projectKey, userId } = userConfig;
    
    if (!projectKey || !userId || !pusherToken) {
      return null;
    }

    return new Pusher(pusherToken, {
      cluster: pusherCluster ,
      authEndpoint: validBaseUrl + 'pusher/presence/auth/visitor?userid=' + userId,
      auth: {
        headers: {
          Authorization: 'Bearer ' + projectKey,
        },
      },
    });
  };

  const subscribeToChannel = data => {
    removeAllSubscriptionAndBindingInPusher();

    if (subscriptionChannelRef.current) {
      pusher.current = createPusherObject();
      let channel = pusher.current && pusher.current.subscribe(subscriptionChannelRef.current);
      if(channel) {
        channel.bind('server-message', handlePusherServerMessage);

        channel.bind('client-widget-message', handleOtherClientMessages);

        channel.bind('pusher:subscription_succeeded', function() {
          isPusherConnected.current = true;
          setIsPusherConnected(true);
          if (data && data.callApi && data.cid) {
            getUserConversation({
              meta: {cid: data.cid, checkSendingMessages},
            });
          }
        });

        channel.bind('pusher:subscription_error', function(status) {
          isPusherConnected.current = false;
          setTimeout(() => {
            subscribeToChannel();
          }, 2000);
        });
      }
    }
  };

  const handleConnectionChange = () => {
    const condition = navigator.onLine ? NETWORK_STATUS.online : NETWORK_STATUS.offline;
    if (condition === NETWORK_STATUS.offline) {
      handleConnectionStateChange({ current: condition });
    }
    if (condition === NETWORK_STATUS.online) {
      if (pusher.current && pusher.current.connection.state === PUSHER_STATES.connected) {
        handleConnectionStateChange({ current: condition });
      }
    }
  };

  const handleConnectionStateChange = state => {
    switch (state.current) {
      case PUSHER_STATES.online:
      case PUSHER_STATES.connected:
        if (networkStatus.current === NETWORK_STATUS.offline) {
          setTimeout(() => {
            setNativeNotification({
              variant: NATIVE_NOTIFICATION_VARIANT.success,
              message: 'Connected',
            });
            networkStatus.current = NETWORK_STATUS.online;
            setInternetStatus({ data: NETWORK_STATUS.online });
          }, 5000);

          setTimeout(() => {
            setNativeNotification({
              variant: NATIVE_NOTIFICATION_VARIANT.success,
              message: null,
            });
          }, 10000);
        }

        break;
      case PUSHER_STATES.offline:
      case PUSHER_STATES.connecting:
        if (networkStatus.current === NETWORK_STATUS.online) {
          setNativeNotification({
            variant: NATIVE_NOTIFICATION_VARIANT.error,
            message: 'No internet connection',
          });
        }
        networkStatus.current = NETWORK_STATUS.offline;
        setInternetStatus({ data: NETWORK_STATUS.offline });
        break;
      case PUSHER_STATES.unavailable:
        networkStatus.current = NETWORK_STATUS.offline;
        setInternetStatus({ data: NETWORK_STATUS.offline });
        break;

      default:
        break;
    }
  };

  const checkSendingMessages = data => {
    if (networkStatus.current === NETWORK_STATUS.online) {
      if(isPusherConnected.current)
        handleSendingMessageToPusher({ meta: { pusher: pusher.current, data } });
      else {
        messagesToBeSentToPusher.current.push({ meta: { pusher: pusher.current, data } });
        // setTimeout(() => {
        //   handleSendingMessageToPusher({ meta: { pusher: pusher.current, data } })
        // }, 2000);
      }
    }
  };

  const showWidget = () => {
    let eventType = null;
    if (userData.settings.widget.show) {
      const currentActivePage =
        getFromLocalStorage(localStorageTemplates.widgetActivePage) || PAGE.LAUNCHER;
      if (isSessionActive()) {
        setActivePageStart(currentActivePage);
        showInitialPopup();
      } else {
        setTimeout(() => {
          if (!currentPage || currentPage === '') {
            setActivePageStart(PAGE.LAUNCHER);
            showInitialPopup();
          }
        }, userData.settings.widget.delayTime);
      }
      eventType = eventTypes.WIDGET_SHOWN;
    } else {
      eventType = eventTypes.WIDGET_NOT_SHOWN;
    }
    saveEventToLocalStorage({
      eventType,
      timestamp: Date.now(),
      url: userConfig.blogUrl,
      props: {
        channelId: currentChannel,
      },
    });
  };

  const showInitialPopup = () => {
    if (userData.popupMessage) {
      const currentActivePage = getFromLocalStorage(localStorageTemplates.widgetActivePage);
      if (isSessionActive()) {
        if (!currentActivePage || currentActivePage === PAGE.LAUNCHER) {
          setPopup({
            popupMessage: userData.popupMessage.message,
            abtestId: userData.popupMessage.abtestId,
            stepId: userData.popupMessage.stepId,
            stepUid: userData.popupMessage.stepUid,
            abtestVariantId: userData.popupMessage.abtestVariantId,
            sender: userData.sender,
          });
          if (userData.sender) {
            setActivePageStart(PAGE.POPUP_CONNECTED);
          } else if ((userData.formTrigger || userData.elementTrigger) && !isConversationDisabled(currentChannel)) {
            setActivePageStart(PAGE.DIMMED_CONVO);
          } else {
            setActivePageStart(PAGE.POPUP_NORMAL);
          }
          if (userData.popupMessage.info) {
            setPopupToNotificationMessageStart({ message: userData.popupMessage.message || '' });
          }
        }
      } else if (userData.settings.popupMessage.show) {
        setTimeout(() => {
          if (!window.insentCurrentPage || window.insentCurrentPage === PAGE.LAUNCHER) {

            setPopup({
              popupMessage: userData.popupMessage.message,
              messageTimestamp: userData.messageTimestamp,
              abtestId: userData.popupMessage.abtestId,
              stepId: userData.popupMessage.stepId,
              stepUid: userData.popupMessage.stepUid,
              abtestVariantId: userData.popupMessage.abtestVariantId,
              sender: userData.sender,
            });
            if (userData.sender) {
              setActivePageStart(PAGE.POPUP_CONNECTED);
            } else if ((userData.formTrigger||userData.elementTrigger) && !isConversationDisabled(currentChannel)) {
              setActivePageStart(PAGE.DIMMED_CONVO);
            } else {
              setActivePageStart(PAGE.POPUP_NORMAL);
            }
            if (userData.popupMessage.info) {
              setPopupToNotificationMessageStart({ message: userData.popupMessage.message || '' });
            }
          }
        }, userData.settings.popupMessage.delayTime);
      }
    }
    else if((userData.formTrigger||userData.elementTrigger) && !isConversationDisabled(currentChannel)) {
      setTimeout(() => {
        setActivePageStart(PAGE.DIMMED_CONVO);
      }, userData.settings.popupMessage.delayTime);
    }
  };

  const sendDataToServer = data => {
    switch (data.type) {
      case SENDING_MESSAGE_TYPE.bot:
        if(isPusherConnected.current) {
          if(messagesToBeSentToPusher.current.length !== 0) {
            messagesToBeSentToPusher.current.push({
              meta: {pusher: pusher.current, data},
            })
          }
          else {
            handleSendingMessageToPusher({
              meta: {pusher: pusher.current, data},
            });
          }
        }
        else {
          messagesToBeSentToPusher.current.push({
            meta: {pusher: pusher.current, data},
          })
        }
        break;
      case SENDING_MESSAGE_TYPE.message:
        checkSendingMessages(data);
        break;
      case SENDING_MESSAGE_TYPE.cookies:
        if(isPusherConnected.current) {
          if(messagesToBeSentToPusher.current.length !==0) {
            messagesToBeSentToPusher.current.push({
              meta: {pusher: pusher.current, data},
            })
          }
          else {
            handleSendingMessageToPusher({
              meta: {pusher: pusher.current, data},
            });
          }
        }
        else {
          messagesToBeSentToPusher.current.push({
            meta: {pusher: pusher.current, data},
          })
        }
        break;
      default:
        break;
    }
  };

  //handler for Client-widget-messages from other tabs/windows inorder to sync responses.
  const handleOtherClientMessages = async data => {
    await processClientMessages({
      meta: {
        data,
        setShowNewMessageNotification,
        setPopup,
        isWindowFocused,
        setNativeNotification: setNativeNotification,
      },
    });
  };

  const handlePusherServerMessage = async data => {
    if(serverMessagesQueue.length !== 0){
      serverMessagesQueue.push({
        meta: {
          data,
          setShowNewMessageNotification,
          setPopup,
          isWindowFocused,
          setNativeNotification: setNativeNotification,
        },
      });
      setServerMessagesQueue(serverMessagesQueue);
      return;
    }
    await processPusherUpdates({
      meta: {
        data,
        setShowNewMessageNotification,
        setPopup,
        isWindowFocused,
        setNativeNotification: setNativeNotification,
      },
    });
  };

  const renderPopup = () => {
    if (!popup || !popup.popupMessage || isConversationDisabled(currentChannel)) {
      setActivePageStart(PAGE.LAUNCHER);
      return null;
    } else {
      return (
        <NewPopup
            popup={popup}
            userConfig={userConfig}
            currentChannel={currentChannel}
            sendDataToServer={sendDataToServer}
            isPusherConnected={isPusherConnected}
            {...props} />
      );
    }
  };

  return (
    <AppContainer id="insent-app-container">
      {currentPage === PAGE.LAUNCHER && (
        <Launcher
          setPopup={setPopup}
          userConfig={userConfig}
          currentChannel={currentChannel}
          userData={userData}
          {...props}
        />
      )}
      {currentPage === PAGE.HOME && (
        <Home
          nativeNotification={nativeNotification}
          userConfig={userConfig}
          currentChannel={currentChannel}
          {...props}
        />
      )}
      {(currentPage === PAGE.CONVO || currentPage === PAGE.DIMMED_CONVO) && (
        <>
          {currentPage === PAGE.DIMMED_CONVO && (<Dimmer />)}
          <Conversation
            nativeNotification={nativeNotification}
            setNativeNotification={setNativeNotification}
            sendDataToServer={sendDataToServer}
            showNewMessageNotification={showNewMessageNotification}
            subscribeToChannel={subscribeToChannel}
            isPusherConnected={isPusherConnected}
            userData={userData}
            {...props}
          />
        </>
      )}
      {(currentPage === PAGE.POPUP_NORMAL ||
        currentPage === PAGE.POPUP_CONNECTED ||
        currentPage === PAGE.POPUP_NEW_MESSAGE) &&
        renderPopup()}
    </AppContainer>
  );
};

App.propTypes = {
  getInitialState: PropTypes.func,
  isShowWidget: PropTypes.bool,
  currentPage: PropTypes.string,
  subscriptionChannel: PropTypes.string,
  userData: PropTypes.object,
  processPusherUpdates: PropTypes.func,
  processClientMessages: PropTypes.func,
  popupToNotificationMessage: PropTypes.string,
};

export const mapStateToProps = (state, props) => {
  return createStructuredSelector({
    isShowWidget: selectors.makeSelectIsShowWidget(),
    currentPage: selectors.makeSelectCurrentPage(),
    subscriptionChannel: selectors.makeSelectSubscriptionChannel(),
    userData: selectors.makeSelectCurrentUser(),
    triggerForms: selectors.makeSelectTriggerForms(),
    triggerElements: selectors.makeSelectTriggerElements(),
    formFields: selectors.makeSelectMappedFormFields(),
    userConfig: selectors.makeSelectConfig(),
    sendingMessages: selectors.makeSelectSendingMessages(),
    currentChannel: selectors.makeSelectCurrentChannel(),
    networkCurrentStatus: selectors.makeSelectNetworkStatus(),
    conversationLoading: selectors.makeSelectConversationLoading(),
    userConversation: selectors.makeSelectCurrentUserConversation(),
    parentFrameSize: selectors.makeSelectParentFrameSize(),
    popupToNotificationMessage: selectors.makeSelectPopupToNotificationMessage(),
    isMessageUnread: selectors.makeSelectIsMessageUnread(),
    notificationRead: selectors.makeSelectNotificationRead(),
    agentNewMessageList: selectors.makeSelectAgentNewMessageList(),
    initiateSocketConnection: selectors.makeSelectInitiateSocketConnection(),
    delayFlag: selectors.makeSelectDelayFlag(),
    serverMessagesQueue: selectors.makeSelectServerMessagesQueue(),
    userSettingBot: selectors.makeSelectCurrentUserSettingBot(),
  });
};

const handleSendingDebugEvent = ({ meta, payload, dispatch }) => {
  /** this was used for additional custom logic for debugging setTimeSpent bug */
  return dispatch(actions.setTimeSpent.start({ meta, payload }));
};

export const mapDispatchToProps = dispatch => {
  return {
    getInitialState: () => dispatch(actions.getInitialState.start()),
    getChannelId: ({ meta }) => dispatch(actions.getChannelId.start({ meta })),
    processPusherUpdates: ({ meta }) => dispatch(actions.processPusherMessages({ meta })),
    processClientMessages: ({ meta }) => dispatch(actions.processClientMessages({ meta })),
    setActivePageStart: page => dispatch(actions.setActivePage.start(page)),
    removeSendingMessage: ({ meta }) => dispatch(actions.removeFromSendingMessages({ meta })),
    handleSendingMessageToPusher: ({ meta }) =>
      dispatch(actions.handleSendingMessagesToPusher({ meta })),
    setCurrentChannel: ({channelId}) => dispatch(actions.setCurrentChannel({channelId})),
    setInternetStatus: ({ data }) => dispatch(actions.setNetworkStatus({ data })),
    updateReadStatus: () => dispatch(actions.updateMessageReadStatus()),
    getUserConversation: ({ meta }) => dispatch(actions.getUserConversation.start({ meta })),
    clearUserConversation: () => dispatch(actions.clearUserConversation()),
    setPopupToNotificationMessageStart: ({ message }) =>
      dispatch(actions.setPopupToNotificationMessage({ message })),
    setTimeSpentStart: ({ meta, payload }) => handleSendingDebugEvent({ meta, payload, dispatch }),
    setIsMessageUnreadStart: status => dispatch(actions.setIsMessageUnread(status)),
    setIsPusherConnected: status => dispatch(actions.setIsPusherConnected(status)),
    setNotificationRead: channels => dispatch(actions.setNotificationRead(channels)),
    setWidgetVisibility: ({ meta }) => dispatch(actions.setWidgetVisibility({ meta })),
    handleWidgetEvent: ({ meta }) => dispatch(actions.handleWidgetEvent({ meta })),
    setWidgetSoundStatus: ({ meta }) => dispatch(actions.setWidgetSoundStatus({ meta })),
    setServerMessagesQueue: messageQueue => dispatch(actions.setServerMessagesQueue((messageQueue))),
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(App);
